import { useState } from 'react';
import { Link } from 'react-router-dom';
import { categories, mainSiteUrl } from '@/mocks/categories';

const formSubmitAddr = "https://readdy.ai/api/form/d9b085cngs93pt5sh6l0";

export default function Footer() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error' | 'loading'>('idle');
  const [statusMessage, setStatusMessage] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypotVal = (formData.get('website_alt') as string || '').trim();
    if (honeypotVal) {
      setStatus('success');
      setStatusMessage('Grazie per l\'iscrizione!');
      setEmail('');
      return;
    }
    formData.delete('website_alt');

    setStatus('loading');

    try {
      const searchParams = new URLSearchParams();
      formData.forEach((value, key) => {
        searchParams.append(key, value as string);
      });

      const res = await fetch(formSubmitAddr, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: searchParams.toString(),
      });

      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch (_e) { parsed = null; }

      const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText;

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setStatusMessage('Grazie per l\'iscrizione! Controlla la tua email.');
        setEmail('');
      } else if (serverMsg && (serverMsg.includes('spam') || serverMsg.includes('form data is spam'))) {
        setStatus('error');
        setStatusMessage('Si è verificato un errore. Riprova più tardi.');
      } else {
        setStatus('error');
        setStatusMessage(serverMsg || 'Si è verificato un errore. Riprova più tardi.');
      }
    } catch (_err) {
      setStatus('error');
      setStatusMessage('Errore di rete. Riprova più tardi.');
    }
  };

  const catCols = [
    categories.slice(0, 5),
    categories.slice(5, 10),
    categories.slice(10, 14),
  ];

  return (
    <footer className="bg-foreground-900 pt-16 md:pt-20 pb-8">
      <div className="px-4 md:px-6 lg:px-10 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 mb-12 md:mb-16">
          <div className="w-full lg:w-[28%]">
            <Link to="/" className="inline-flex items-center gap-2.5 mb-5 group">
              <span className="font-heading text-xl font-bold text-background-50 tracking-tight">
                Itaobuy Spread
              </span>
            </Link>
            <p className="text-sm text-foreground-300 leading-relaxed max-w-xs">
              Il punto di riferimento italiano per scoprire Itaobuy Spreadsheet aggiornati, guide e consigli per lo shopping internazionale.
            </p>
          </div>

          <div className="w-full lg:w-[44%] grid grid-cols-2 sm:grid-cols-3 gap-8">
            {catCols.map((col, colIdx) => (
              <div key={colIdx}>
                <p className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">
                  {colIdx === 0 ? 'Categorie 1-5' : colIdx === 1 ? 'Categorie 6-10' : 'Altre'}
                </p>
                <ul className="space-y-2.5">
                  {col.map((cat) => (
                    <li key={cat.id}>
                      <a
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="text-sm text-foreground-400 hover:text-background-50 transition-colors duration-200"
                      >
                        {cat.nameIt}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="w-full lg:w-[28%]">
            <p className="text-sm font-semibold text-background-50 mb-4">Newsletter</p>
            <p className="text-sm text-foreground-400 mb-4 leading-relaxed">
              Ricevi aggiornamenti, nuove guide e prodotti selezionati direttamente nella tua casella email.
            </p>
            <form
              onSubmit={handleNewsletterSubmit}
              className="flex gap-2"
              data-readdy-form=""
            >
              <input
                type="text"
                name="website_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
                className="form-honeypot"
              />
              <input
                type="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                placeholder="La tua email"
                className="flex-1 min-w-0 px-4 py-2.5 rounded-lg bg-foreground-800 text-sm text-background-50 placeholder:text-foreground-500 outline-none border border-foreground-700 focus:border-primary-500 transition-colors"
              />
              <button
                type="submit"
                disabled={status === 'loading'}
                className="px-4 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
              >
                {status === 'loading' ? (
                  <i className="ri-loader-4-line animate-spin"></i>
                ) : (
                  <i className="ri-send-plane-fill text-base"></i>
                )}
              </button>
            </form>
            {(status === 'success' || status === 'error') && (
              <p className={`text-xs mt-2 ${status === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
                {statusMessage}
              </p>
            )}
          </div>
        </div>

        <div className="border-t border-foreground-700/50 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-1 text-sm text-foreground-400">
            <span className="font-heading text-base">&copy;</span>
            <span>2026 Itaobuy Spread. Tutti i diritti riservati.</span>
          </div>
          <div className="flex items-center gap-5">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4"
            >
              Privacy
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4"
            >
              Disclaimer
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="text-sm text-foreground-400 hover:text-background-50 transition-colors underline underline-offset-4"
            >
              Contatti
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}